// First, and deliberately so: this installs MapLibre's worker URL, and it has to be in place
// before any component constructs a Map. See the module for what happens when it is not — the
// short version is that every vector and GeoJSON layer hangs forever, in silence.
import './lib/maplibre.ts';

import { mount } from 'svelte';
import App from './App.svelte';
import './app.css';

/**
 * Svelte 5 mounts through `mount()` rather than `new App()`. The non-null assertion is the one
 * place it is justified: `index.html` is in this repository and contains the element.
 */
const target = document.getElementById('app');
if (target === null) throw new Error('#app is missing from index.html');

export default mount(App, { target });
